const AboutPage = () => {
  const stats = [
    {
      icon: 'fas fa-book-open',
      number: '20+',
      label: 'دورة وقصة تفاعلية',
      color: 'from-blue-500 to-indigo-600'
    },
    {
      icon: 'fas fa-file-alt',
      number: '1000+',
      label: 'صفحة محتوى غني',
      color: 'from-purple-500 to-pink-600'
    },
    {
      icon: 'fas fa-language',
      number: '100%',
      label: 'بالدارجة الجزائرية',
      color: 'from-green-500 to-emerald-600'
    }
  ];

  const values = [
    {
      icon: 'fas fa-heart',
      title: 'الجودة أولاً',
      desc: 'نلتزم بتقديم محتوى تعليمي عالي الجودة ومدروس بعناية',
      color: 'from-red-500 to-pink-500'
    },
    {
      icon: 'fas fa-language',
      title: 'بالدارجة الجزائرية',
      desc: 'كل المحتوى بالدارجة الجزائرية باش الفهم يكون سهل وواضح',
      color: 'from-blue-500 to-indigo-600'
    },
    {
      icon: 'fas fa-rocket',
      title: 'التطور المستمر',
      desc: 'نضيف محتوى جديد باستمرار ونحسن من المنصة دائماً',
      color: 'from-purple-500 to-pink-600'
    },
    {
      icon: 'fas fa-users',
      title: 'المجتمع أولاً',
      desc: 'نستمع لآراء المتعلمين ونطور المنصة حسب احتياجاتهم',
      color: 'from-green-500 to-emerald-600'
    }
  ];

  return (
    <div className="relative z-10 min-h-screen bg-gradient-to-b from-white via-gray-50 to-white overflow-x-hidden">
      {/* Blue gradient blobs */}
      <div className="absolute top-0 left-0 w-64 h-64 md:w-80 md:h-80 lg:w-96 lg:h-96 bg-primary/20 rounded-full blur-3xl"></div>
      <div className="absolute bottom-10 right-10 w-48 h-48 md:w-64 md:h-64 lg:w-80 lg:h-80 bg-blue-500/25 rounded-full blur-3xl"></div>
      <div className="absolute bottom-0 right-0 w-64 h-64 md:w-80 md:h-80 lg:w-96 lg:h-96 bg-secondary/5 rounded-full blur-3xl"></div>

      <div className="container mx-auto px-4 py-24 relative z-10">
        <div className="max-w-[1200px] mx-auto">
          {/* Header */}
          <div className="text-center mb-20">
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-primary/10 text-primary rounded-full mb-6 font-semibold text-sm">
              <i className="fas fa-info-circle"></i>
              <span>من نحن</span>
            </div>
            <h1 className="text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-black text-text mb-6 leading-tight">
              <span className="text-primary">Allemni</span> - منصة التعليم الإلكتروني
            </h1>
            <p className="text-xl md:text-2xl text-text2 leading-relaxed max-w-[900px] mx-auto">
              منصة تعليمية جزائرية 100% نقدم دورات ودروس بطريقة مبسطة وواضحة لتسهيل الفهم على الجميع
            </p>
          </div>

          {/* Stats */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-20">
            {stats.map((stat, index) => (
              <div
                key={index}
                className="group relative bg-white rounded-3xl p-6 md:p-8 shadow-xl border-2 border-gray-100 hover:border-primary/30 transition-all duration-300 hover:-translate-y-2"
              >
                <div className="text-center">
                  <div className={`w-20 h-20 bg-gradient-to-br ${stat.color} rounded-2xl flex items-center justify-center text-white text-3xl mx-auto mb-6 shadow-lg transform transition-transform duration-300 group-hover:scale-110 group-hover:rotate-6`}>
                    <i className={stat.icon}></i>
                  </div>
                  <div className={`text-5xl font-black bg-gradient-to-r ${stat.color} bg-clip-text text-transparent mb-2`}>
                    {stat.number}
                  </div>
                  <div className="text-lg text-text2 font-semibold">{stat.label}</div>
                </div>
              </div>
            ))}
          </div>

          {/* Vision Section */}
          <div className="bg-white rounded-3xl p-6 md:p-10 lg:p-12 shadow-xl border-2 border-gray-100 mb-20">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-12 h-12 bg-gradient-to-br from-primary to-secondary rounded-xl flex items-center justify-center text-white text-xl">
                <i className="fas fa-eye"></i>
              </div>
              <h2 className="text-4xl md:text-5xl font-black text-text">رؤيتنا</h2>
            </div>
            <p className="text-xl text-text2 leading-relaxed mb-6">
              نحلمو بمنصة تعليمية جزائرية كبيرة نقدمو فيها دورات ودروس بالدارجة المحلية باش كل واحد يقدر يتعلم ويفهم بلا تعقيد. نؤمنو بأن التعليم بلغة الناس هو المفتاح للنجاح.
            </p>
            <p className="text-xl text-text2 leading-relaxed">
              نسعاو نوفرو محتوى تعليمي عالي الجودة في مختلف المجالات من التعليم الأساسي للأطفال حتى اللغات والمهارات الحياتية، كل شيء بطريقة احترافية ومبسطة.
            </p>
          </div>

          {/* Values Section */}
          <div className="mb-20">
            <div className="text-center mb-12">
              <h2 className="text-4xl md:text-5xl font-black text-text mb-4">قيمنا</h2>
              <p className="text-xl text-text2 max-w-[700px] mx-auto">
                المبادئ اللي نشتغلو بيها ونؤمنو بيها في كل يوم
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {values.map((value, index) => (
                <div
                  key={index}
                  className="group bg-white rounded-3xl p-6 md:p-8 shadow-xl border-2 border-gray-100 hover:border-primary/30 transition-all duration-300 hover:-translate-y-2"
                >
                  <div className="flex items-start gap-6">
                    <div className={`w-16 h-16 bg-gradient-to-br ${value.color} rounded-2xl flex items-center justify-center text-white text-2xl flex-shrink-0 shadow-lg transform transition-transform duration-300 group-hover:scale-110 group-hover:rotate-6`}>
                      <i className={value.icon}></i>
                    </div>
                    <div className="flex-1">
                      <h3 className="text-2xl font-black text-text mb-3">{value.title}</h3>
                      <p className="text-lg text-text2 leading-relaxed">{value.desc}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Mission Section */}
          <div className="bg-gradient-to-br from-primary via-primary-dark to-secondary rounded-3xl p-6 md:p-10 lg:p-12 shadow-2xl relative overflow-hidden">
            {/* Background decoration */}
            <div className="absolute inset-0 opacity-20">
              <div className="absolute inset-0" style={{
                backgroundImage: `radial-gradient(circle at 20% 30%, rgba(255,255,255,0.3) 0%, transparent 50%), radial-gradient(circle at 80% 70%, rgba(255,255,255,0.2) 0%, transparent 50%)`
              }}></div>
            </div>

            <div className="relative z-10">
              <div className="flex items-center gap-3 mb-6">
                <div className="w-12 h-12 bg-white/20 backdrop-blur-sm rounded-xl flex items-center justify-center text-white text-xl">
                  <i className="fas fa-bullseye"></i>
                </div>
                <h2 className="text-4xl md:text-5xl font-black text-white">مهمتنا</h2>
              </div>
              <p className="text-xl md:text-2xl text-white/95 leading-relaxed mb-6">
                نخليو التعليم متاح للجميع بطريقة سهلة ومفهومة باستخدام اللغة الدارجة الجزائرية، ونوفرو محتوى تعليمي عالي الجودة يساعد المتعلمين باش يحققو أهدافهم.
              </p>
              <div className="flex flex-wrap gap-4">
                <div className="flex items-center gap-2 bg-white/10 backdrop-blur-sm px-4 py-2 rounded-xl text-white">
                  <i className="fas fa-check-circle"></i>
                  <span>محتوى عالي الجودة</span>
                </div>
                <div className="flex items-center gap-2 bg-white/10 backdrop-blur-sm px-4 py-2 rounded-xl text-white">
                  <i className="fas fa-check-circle"></i>
                  <span>بالدارجة الجزائرية</span>
                </div>
                <div className="flex items-center gap-2 bg-white/10 backdrop-blur-sm px-4 py-2 rounded-xl text-white">
                  <i className="fas fa-check-circle"></i>
                  <span>تطوير مستمر</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutPage;
